module.exports = __webpack_public_path__ + "img/Association_VPA_01.f360d54a.jpg";